import { useEffect, useState } from 'react';

type Options = {
  active?: boolean;
  intervalMs?: number;
};

export const useSceneCycle = (count: number, { active = true, intervalMs = 2600 }: Options = {}) => {
  const [scene, setScene] = useState(0);

  useEffect(() => {
    if (active) {
      setScene(0);
    }
  }, [active]);

  useEffect(() => {
    if (!active || count <= 1) {
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    const timer = setInterval(() => {
      setScene((prev) => (prev + 1) % count);
    }, intervalMs);

    return () => clearInterval(timer);
  }, [active, count, intervalMs]);

  return scene;
};
